import { NetworkService } from "./network-service";

const API_BASE_URL = process.env.REACT_APP_API_EXECUTION_ADDRESS;

const handlePromptError = (endpoint, error)=>{
    console.error(`Errore durante l'operazione su ${endpoint}: `, error);
}

export const PromptService = {
    getAllPrompts:(callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/prompts/`;
        NetworkService.get(url,(data)=>{
            callback(data)
        }, (error)=>{
            handlePromptError("elenco dei prompt", error);
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    createPrompt: (promptData, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/prompts/`;
        NetworkService.post(url,promptData,callback, (error)=>{
            handlePromptError("creazione del prompt", error);
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    getPrompt: (promptId, callback,errorCallback)=>{
        const url = `${API_BASE_URL}/api/prompts/${promptId}/`;
        NetworkService.get(url, callback, (error)=>{
            if(errorCallback){
                errorCallback(error);
            }
        });
    },

    updatePrompt: (promptId, payload, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/prompts/${promptId}/`;
        NetworkService.put(url, payload, callback, (error)=>{
            handlePromptError(`aggiornamento del prompt con ID ${promptId}`, error);
            if(errorCallback){
                errorCallback(error);
            }
        })
    },

    deletePrompt:(promptId, callback, errorCallback)=>{
        const url = `${API_BASE_URL}/api/prompts/${promptId}/`;
        NetworkService.delete(url, callback, (error)=>{
            handlePromptError(`eliminazione del prompt con ID ${promptId}`, error);
            if (errorCallback) {
                errorCallback(error);
            }
        });
    },
}
